import React from "react";
import Context from "../../../../Context";
import { useToast } from "../../../../components/ui";
import { FaCheckCircle, FaTimes } from "react-icons/fa";
import { OrderSlips } from "./OrderSlips";
import { OrderNotes } from "./OrderNotes";

export const NoteAndSlips = ({ order }) => {
  const { callApi } = Context();
  const { toast } = useToast();

  const toastSuccess = () =>
    toast({
      className: "bg-emerald-600 text-white font-semibold",
      title: (
        <div className="flex gap-2 items-center">
          <FaCheckCircle /> อัปเดตข้อมูลสำเร็จ
        </div>
      ),
    });

  const toastError = (message) =>
    toast({
      className: "bg-rose-600 text-white font-semibold",
      title: (
        <div className="flex gap-2 items-center">
          <FaTimes /> อัปเดตข้อมูลไม่สำเร็จ
        </div>
      ),
      description: message,
    });

  return (
    <div className="w-full">
      <OrderSlips
        order={order}
        callApi={callApi}
        toastSuccess={toastSuccess}
        toastError={toastError}
      />
      <OrderNotes
        order={order}
        callApi={callApi}
        toastSuccess={toastSuccess}
        toastError={toastError}
      />
    </div>
  );
};
